/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { FC, PropsWithChildren } from 'react'
import Animated, { LinearTransition } from 'react-native-reanimated'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { styled, useTheme } from 'styled-components/native'

import { SnackBar } from 'ui/designSystem/Snackbar/SnackBar'
import { useSnackbarProps } from 'ui/designSystem/Snackbar/snackBar.store'

export const SnackBarWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { isDesktopViewport } = useTheme()
  const snackbarsProps = useSnackbarProps()
  const { top } = useSafeAreaInsets()

  return (
    <React.Fragment>
      {snackbarsProps.length > 0 ? (
        <Container top={top}>
          {snackbarsProps.map(({ onClose, label, animationDuration, type, id }, index) => (
            <Animated.View
              style={{ zIndex: 1000 + index }}
              key={id}
              layout={LinearTransition.duration(500).springify()}>
              <SnackBar
                variant={isDesktopViewport ? 'large' : 'default'}
                id={id}
                onClose={onClose}
                label={label}
                animationDuration={animationDuration}
                type={type}
              />
            </Animated.View>
          ))}
        </Container>
      ) : null}
      {children}
    </React.Fragment>
  )
}

const Container = styled.View<{ top: number }>(({ theme, top }) => ({
  marginHorizontal: theme.designSystem.size.spacing.xs,
  marginVertical: theme.designSystem.size.spacing.xs,
  top: theme.isDesktopViewport ? undefined : top,
  bottom: theme.isDesktopViewport ? 0 : undefined,
  left: theme.isDesktopViewport ? undefined : 0,
  right: 0,
  position: 'absolute',
  zIndex: 1000,
}))
